import { LocalStoreType } from "../constants/local-type";

const ignore = ['favorite', 'memoid'];
export const clearLocalStorageOnLogout = () => {
  Object.keys(localStorage).forEach((key) =>
    !ignore.includes(key) ? localStorage.removeItem(key) : ""
  );

  // clear sessionStorage all
  sessionStorage.clear();
};


export const getDataLocal = (Local :LocalStoreType) => {
  if (!Local) return "null" 
  const data = window.localStorage.getItem(Local)||"";

  if(!data && Local ===LocalStoreType.userData )return "null"
  return data
}